import { storeName } from './types';

const getStateStore = state => state[storeName] || {};
const getDataStore = state => getStateStore(state).data || {};
const getUid = state => getDataStore(state).name || '';
const getOpeningHours = state => getDataStore(state).openingHours || {};
const getWeekDayOpeningList = state => getOpeningHours(state).weekDayOpeningList || [];

export default {
    getDataStore,
    getUid,
    getOpeningHours,
    getWeekDayOpeningList,
};
